/* DLUX announcement marquee. Server HTML holds the message twice (one visible, one aria-hidden).
   This fills each half with aria-hidden clones until it is at least viewport-wide, so the CSS
   translateX(-50%) loop never shows a gap, and sets the duration from a fixed speed so the
   text moves at the same pace whatever the message length or screen width. */
(function () {
  /* Pixels per second. 79 (the old 15 s per copy) was too fast to read on a phone;
     45 reads comfortably and still looks alive. Measured 1 Nov 2026. */
  var SPEED = 45;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function fill(track) {
    var halves = track.querySelectorAll('.dlux-announcement__half');
    if (halves.length !== 2) return;
    var bases = [];
    halves.forEach(function (half) {
      var segments = half.querySelectorAll('.dlux-announcement__segment');
      for (var i = segments.length - 1; i > 0; i--) half.removeChild(segments[i]);
      bases.push(segments[0]);
    });
    if (!bases[0] || !bases[1] || reduceMotion.matches) return;
    var width = bases[0].offsetWidth;
    var target = Math.max(track.parentElement ? track.parentElement.clientWidth : 0, window.innerWidth);
    if (!width || !target) return;
    var count = Math.ceil(target / width);
    for (var n = 1; n < count; n++) {
      bases.forEach(function (base, i) {
        var clone = base.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        halves[i].appendChild(clone);
      });
    }
    track.style.setProperty('--dlux-marquee-duration', Math.round((width * count) / SPEED) + 's');
  }
  function run() {
    document.querySelectorAll('.dlux-announcement__track').forEach(fill);
  }
  var timer;
  window.addEventListener('resize', function () { clearTimeout(timer); timer = setTimeout(run, 150); });
  if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', run);
  document.addEventListener('shopify:section:load', run);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
